import dayjs, { DATE_FORMAT } from 'utils/dayjs';
import 'dayjs/locale/en-gb';

dayjs.locale('en-gb');

import type { DateRangeType } from 'models/dateRange';

export function generateRangeFromType(value: {
  type: string;
  from?: string;
  to?: string;
}) {
  const returnValue = { type: value.type } as {
    type: DateRangeType;
    from: string;
    to: string;
  };
  if (value.type == 'custom') {
    returnValue.to = dayjs(value.to, DATE_FORMAT)
      .endOf('day')
      .format(DATE_FORMAT);
    returnValue.from = dayjs(value.from, DATE_FORMAT)
      .startOf('day')
      .format(DATE_FORMAT);
  } else {
    const rangeToToday = dayjs().format(DATE_FORMAT);
    const yesterday = dayjs()
      .subtract(1, 'days')
      .startOf('day')
      .format(DATE_FORMAT);

    switch (value.type) {
      case 'today':
        returnValue.from = dayjs().startOf('day').format(DATE_FORMAT);
        returnValue.to = rangeToToday;
        break;
      case 'yesterday':
        returnValue.from = yesterday;
        returnValue.to = yesterday;
        break;
      case 'd7':
        returnValue.from = dayjs()
          .subtract(7, 'days')
          .startOf('day')
          .format(DATE_FORMAT);
        returnValue.to = rangeToToday;
        break;
      case 'd30':
        returnValue.from = dayjs()
          .subtract(30, 'days')
          .startOf('day')
          .format(DATE_FORMAT);
        returnValue.to = rangeToToday;
        break;
      case 'last_week':
        returnValue.from = dayjs()
          .subtract(7, 'days')
          .startOf('week')
          .format(DATE_FORMAT);
        returnValue.to = dayjs()
          .subtract(7, 'days')
          .endOf('week')
          .format(DATE_FORMAT);
        break;
      case 'last_month':
        returnValue.from = dayjs()
          .subtract(1, 'months')
          .startOf('month')
          .format(DATE_FORMAT);
        returnValue.to = dayjs()
          .subtract(1, 'months')
          .endOf('month')
          .format(DATE_FORMAT);
        break;
      case 'last_year':
        returnValue.from = dayjs()
          .subtract(1, 'year')
          .startOf('year')
          .format(DATE_FORMAT);
        returnValue.to = dayjs()
          .subtract(1, 'year')
          .endOf('year')
          .format(DATE_FORMAT);
        break;
      case 'this_week':
        returnValue.from = dayjs().startOf('week').format(DATE_FORMAT);
        returnValue.to = rangeToToday;
        break;
      case 'this_month':
        returnValue.from = dayjs().startOf('month').format(DATE_FORMAT);
        returnValue.to = rangeToToday;
        break;
      case 'this_year':
        returnValue.from = dayjs().startOf('year').format(DATE_FORMAT);
        returnValue.to = rangeToToday;
        break;
      default:
        break;
    }
  }
  return returnValue;
}
